import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeDifference',
    standalone: true
})
export class TimeDifferencePipe implements PipeTransform {

  transform(startTimestamp: number, endTimestamp: number): string {
    const diffInMs = Math.abs(endTimestamp - startTimestamp);
    const diffInHours = diffInMs / (1000 * 60 * 60);

    // Rounding to two decimal places for precision
    return Math.round(diffInHours * 100) / 100 + " uur";
  }
}
